/**
 * bankFeedQuickStart - Sprint 5 tour engine / Phase B
 * =====================================================
 *
 * Three-step interactive tour that walks a non-accountant through
 * reviewing their first transaction. Anchored to existing data-testids
 * so it works on a brand-new account and Henry's live data alike.
 *
 * NOTE: Step property is `target` (CSS selector), not `anchor` - that
 * is the contract enforced by TourProvider.jsx::TourOverlay.
 */
const bankFeedQuickStartTour = {
  id: 'bank-feed-quickstart',
  title: 'Review your first transaction',
  estimated_seconds: 60,
  steps: [
    {
      target: '[data-testid="tx-filter-chips"]',
      title: 'This is your bank feed at a glance',
      body: 'These chips split your transactions into Review Needed and Completed. Start with Review Needed: those are the ones AkountFly wants your eyes on.',
      placement: 'bottom',
    },
    {
      target: '[data-testid="bf-auto-approve-cta"]',
      title: 'Auto-approve what we already nailed',
      body: 'When we are at least 80% confident about a category, we offer to post the entry for you in one click. Use this to clear easy wins fast.',
      placement: 'bottom',
    },
    {
      target: '[data-testid^="gl-edit-"]',
      title: 'Pick the right category',
      body: 'Click the category to change it. AkountFly remembers your choice: next time a similar transaction lands, it picks the right category automatically.',
      placement: 'right',
    },
    {
      target: '[data-testid^="tx-approve-"]',
      title: 'Approve when you are happy',
      body: 'Hit the thumbs-up to post the transaction to your books. We do all the accounting plumbing behind the scenes: debits, credits, tax, the lot.',
      placement: 'left',
    },
  ],
};

export default bankFeedQuickStartTour;
